import { Query } from '@/_core/cqrs/types/queries';

export interface AccountQueryResult {
    Name: string;
    Email: string;
    SubscribeToNewsletter: boolean;
    UsersWorkspaceCount: number;
    ControlledDomainsCount: number;
    HasPendingEmailAddressChange: boolean;
    RequestedNewEmailAddress: null;
    SlackIsConnected: boolean;
    WorkspaceProperties: null;
    StorymapProperties: null;
    Theme: number;

    ApiToken: string;
    ApiTokenGeneratedAt?: Date;
}

export class AccountQuery extends Query<AccountQueryResult> {
    constructor() {
        super('AccountQuery');
    }
}

export class EmailAddressIsUniqueQuery extends Query<boolean> {
    constructor(public OriginalEmail: string, public NewEmail: string) {
        super('EmailAddressIsUniqueQuery');
    }
}

export class PasswordPolicyQuery extends Query<PasswordPolicyQueryResult> {
    constructor(public Password: string) {
        super('PasswordPolicyQuery');
    }
}

export interface PasswordPolicyQueryResult {
    IsValid: boolean;
    IsMinCharCountInvalid: boolean;
    MinCharCount: number;

    IsMinUpperCharCountInvalid: boolean;
    MinUpperCharCount: number;

    IsMinLowerCharCountInvalid: boolean;
    MinLowerCharCount: number;

    IsMinNumberCountInvalid: boolean;
    MinNumberCount: number;

    IsMinSpecialCharsCountInvalid: boolean;
    MinSpecialCharsCount: number;

    DifferentPasswordRequired: boolean;
    DifferentPasswordCount: number;
}
